/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RegionDriverEarningSettingAdminDto } from '../models/RegionDriverEarningSettingAdminDto';
import type { UpsertRegionDriverEarningSettingAdminRequest } from '../models/UpsertRegionDriverEarningSettingAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RegionDriverEarningSettingsService {
    /**
     * **Required Policy:** `ViewDriverEarning`
     * @returns RegionDriverEarningSettingAdminDto OK
     * @throws ApiError
     */
    public static getAdmin(): CancelablePromise<Array<RegionDriverEarningSettingAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-earnings/region-settings',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriversSalaries`
     * @returns RegionDriverEarningSettingAdminDto OK
     * @throws ApiError
     */
    public static putAdmin({
        regionId,
        requestBody,
    }: {
        regionId: number,
        requestBody?: UpsertRegionDriverEarningSettingAdminRequest,
    }): CancelablePromise<RegionDriverEarningSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/driver-earnings/region-settings/{regionId}',
            path: {
                'regionId': regionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
